import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import DocumentMeta from 'react-document-meta';
import * as authActions from 'redux/modules/auth';
import {getWindowSize} from '../../utils/utils';
import immutable from 'immutable';
import {RxForm, FormManager, Checkbox, FormField} from 'reactis-forms';
import {TextInput} from 'reactis-inputs';
import config from '../../config';

@connect(
	state => ({...state.password}),
	authActions)
export default class Login extends Component {

	static contextTypes= {
		router: React.PropTypes.object,
		user: React.PropTypes.object
	};

	constructor() {
		super();
		this.schema = {
			password: {
				class: TextInput,
				type: 'password',
				autoFocus: true,
				autoComplete: 'off',
				placeholder: 'Heslo',
				className: 'form-control password',
				label: 'Heslo',
				rules: {
					presence: {message: 'Zadejte heslo!'}
				}
			},
			passwordConfirm: {
				class: TextInput,
				type: 'password',
				autoComplete: 'off',
				className: 'form-control password',
				placeholder: 'Heslo pro kontrolu',
				label: 'Heslo pro kontrolu',
				rules: {
					equality: {
						attribute: 'password',
						message: 'Hesla se musejí shodovat!'
					}
				}
			},
		};
		this.form = new FormManager(this.schema);
	}

	handleSubmit() {
		const values = this.form.getValues().toJS();
		this.props.setPassword(this.props.token, values.password).then((result) => {
			if (!result.error) {
				this.props.login({username: this.props.email, password: values.password}).then((result) => {
					if (!result.error) {
						this.context.router.push('/')
					}
				});
			}
		});
	}

	render() {

		return (
			<RxForm ref="form" id="setpassword" form={this.form} className="form-login" onSubmit={() => this.handleSubmit()}>
				<div className="panel panel-body login-form">
						<div className="text-center">
							<img src={config.assets + 'img/logo.png'} style={{height:60}} />
							<h5 className="content-group">Zvolte si přístupové heslo
								<small className="display-block">{this.props.email}</small>
							</h5>
						</div>

						{this.props.error && <div className="errorHandler alert alert-danger">
							{this.props.error}
						</div>}

						<div className="form-group has-feedback has-feedback-left">
								<FormField name="password"/>
								<div className="form-control-feedback">
									<i className="icon-lock2 text-muted"></i>
								</div>
						</div>
						<div className="form-group has-feedback has-feedback-left">
							<FormField name="passwordConfirm"/>
							<div className="form-control-feedback">
								<i className="icon-lock2 text-muted"></i>
							</div>
						</div>
						<div className="form-group">
							<button type="submit" className="btn bg-blue btn-block">Aktivovat účet <i className="icon-arrow-right14 position-right"></i></button>
						</div>
				</div>
			</RxForm>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Login/Activate.js